import React, { FC, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import { COLORS } from 'constants/design';
import Request from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/Request';
import DamageAffectedByTheProcedure from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/DamageAffectedByTheProcedure';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import Audience from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/Audience';
import requestRecap from 'images/requestRecap.svg';
import victimIcon from 'images/victim-icon.svg';
import opposing from 'images/opposing.svg';
import { Listings } from 'containers/AppContainer/typings';
import { CivilProceedingInfo } from 'containers/LawyerLegalProceedingsPage/typings';
import { EMPTY_CIVIL_PROCEEDING_INFO_FIELDS } from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/constants';
import SupportingDocuments from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/SupportingDocuments';
import { get } from 'lodash';

export interface CivilRequestProps {
  intl: IntlShape;
  listings: Listings;
  policyInfo: any;
  setProcedureInstance: Function;
  requestGetDocByDocumentumId: Function;
}

const CivilRequest: FC<CivilRequestProps> = props => {
  const { listings } = props;
  const [civilProceedingInfo, setCivilProceedingInfo] = useState<
    CivilProceedingInfo
  >({
    ...EMPTY_CIVIL_PROCEEDING_INFO_FIELDS,
  });

  return (
    <>
      <CustomAccordion
        title={translate(messages.civilRequestLabelTitle, props)}
        textColor={COLORS.ACCORDION_TEXT_BLACK}
        bgColor={COLORS.ACCORDION_BG_YELLOW}
        image={requestRecap}
      >
        <Request
          listings={listings}
          info={civilProceedingInfo}
          setCivilProceedingInfo={setCivilProceedingInfo}
        />
      </CustomAccordion>
      <CustomAccordion
        title={translate(messages.damageAffectedByTheProcedure, props)}
        textColor={COLORS.ACCORDION_TEXT_BLUE}
        bgColor={COLORS.ACCORDION_BG_BLUE}
        image={victimIcon}
      >
        <DamageAffectedByTheProcedure
          info={civilProceedingInfo}
          sagisVictimInfo={null}
          sagisOpposingParties={null}
        />
      </CustomAccordion>
      <CustomAccordion
        title={translate(messages.audience, props)}
        textColor={COLORS.ACCORDION_TEXT_BLUE}
        bgColor={COLORS.ACCORDION_BG_BLUE}
        image={opposing}
      >
        <Audience
          info={civilProceedingInfo}
          listings={listings}
          setCivilProceedingInfo={setCivilProceedingInfo}
          lossDate={get(props.policyInfo, 'corporeal[0].lossDate', '')}
        />
      </CustomAccordion>
      <CustomAccordion
        title={translate(messages.supportingDocuments, props)}
        textColor={COLORS.ACCORDION_TEXT_BLUE}
        bgColor={COLORS.ACCORDION_BG_BLUE}
        image={opposing}
      >
        <SupportingDocuments
          info={civilProceedingInfo}
          listings={listings}
          setCivilProceedingInfo={setCivilProceedingInfo}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      </CustomAccordion>
    </>
  );
};

export default injectIntl(CivilRequest);
